import { InjectionToken } from '@angular/core';

export const ANALYTICS_WEBSOCKET_URL = new InjectionToken<string>('AnalyticsWebSocketUrl');
